import { CuttingState } from "./CuttingState.d";
import { ShipmentState } from "./ShipmentState.d";
import { ShipmentType } from "./ShipmentType.d";
import { UserType } from "./UserType.d";
import { CordwoodMeasurementType } from "./CordwoodMeasurementType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity ThicknessClasses


export interface ThicknessClass {
    id: ID;

    
    name: string;

    
    description?: string;

    
    minDiameter: number;

    
    maxDiameter: number;

    
    reportNameShort?: string;

    
    scopeGroupId: ID;

    
    reportNameLong?: string;

    
    classId?: ID;

    }

export interface FilterMinMaxRequest {
    list: ListRequest,
    filter: {
        
            minDiameter?: number,
        
    
    

            maxDiameter?: number,
        
    
    

            classId?: ID,
        
    
    classIdInclude: boolean,



        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}



export interface CreateThicknessClass {
    
    name: string;

    
    description?: string;

    
    minDiameter: number;

    
    maxDiameter: number;

    
    reportNameShort?: string;

    
    
    reportNameLong?: string;

    
    classId?: ID;

    }


export interface UpdateThicknessClass {
    
    name: string;

    
    description?: string;

    
    minDiameter: number;

    
    maxDiameter: number;

    
    reportNameShort?: string;

    
    
    reportNameLong?: string;

    
    classId?: ID;

    }

export interface PresentationThicknessClassRequest {
    list: ListRequest,
    filter: {
        name: string,
        nameOr: boolean,
        classId: ID,
        classIdOr: boolean,
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryThicknessClass {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: ThicknessClass): PrimaryThicknessClass | undefined {
        return entity ? new PrimaryThicknessClass(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryThicknessClass {
        return new PrimaryThicknessClass(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryThicknessClass {
        let vals = path?.split('/');
        return new PrimaryThicknessClass(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryThicknessClass[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: ThicknessClass): string {
    let fields = entity ? [
    entity.name,
            entity.classId,
            ] : [];
    return fields.filter(item => item).join(' | ');
}

export class UpdateEntityThicknessClass {
    id: PrimaryThicknessClass;
    data: UpdateThicknessClass;


    constructor(id: PrimaryThicknessClass, data: UpdateThicknessClass) {
        this.id = id;
        this.data = data;
    }
}
